import { useState } from 'react'
import { TabPanel, TabView, TabViewTabChangeParams } from 'primereact/tabview'
import { useTranslation } from 'react-i18next'

// local imports
import { PlanTabs } from 'types/PlanTabs'
import { ICampusServiceExists } from 'service/CampusService'
import FavoriteFirmLocations from './locations/FirmLocations'
import FavoriteSharedLocations from './locations/SharedLocations'
import FavoriteCampusServices from './campus-services'
import { FavoritesTabContainer } from './styled'

interface IFavoritesListProps {
  hasCampusPlan: boolean
  campusVisible: ICampusServiceExists | undefined
  planTabs: PlanTabs[]
}

export default function FavoritesList({ campusVisible, hasCampusPlan, planTabs }: IFavoritesListProps) {
  const { t } = useTranslation()

  const shouldRenderComponent =
    !!campusVisible && campusVisible?.isAnyExist && (hasCampusPlan || campusVisible?.isMeetingServiceExist)
  const hasFirmOffice = planTabs.includes(PlanTabs.OFFICE)
  const hasCommonOffice = planTabs.includes(PlanTabs.COMMON)
  const hasNoPlan = !hasFirmOffice && !hasCommonOffice && !shouldRenderComponent

  /* Set default active tab - according to available service indexes */
  const setTabIndex = () => (hasFirmOffice ? 0 : hasCommonOffice ? 1 : shouldRenderComponent ? 2 : undefined)
  const [activeIndex, setActiveIndex] = useState(setTabIndex)
  const handleTabChange = (e: TabViewTabChangeParams) => setActiveIndex(e.index)

  /* Not render the component if has not favoritable plan found */
  if (hasNoPlan) return null

  return (
    <div style={{ margin: '2rem 0' }}>
      <div className="fre-title mb-2">{t('homepage.favorite-locations')}</div>
      <FavoritesTabContainer>
        <TabView
          renderActiveOnly
          className="on-campus-service-tab"
          activeIndex={activeIndex}
          onTabChange={handleTabChange}>
          {hasFirmOffice && (
            <TabPanel header={t('tabs.company-work')}>
              <FavoriteFirmLocations />
            </TabPanel>
          )}

          {hasCommonOffice && (
            <TabPanel header={t('tabs.shared-office')}>
              <FavoriteSharedLocations />
            </TabPanel>
          )}

          {shouldRenderComponent && (
            <TabPanel header={t('tabs.on-campus-services')}>
              <FavoriteCampusServices />
            </TabPanel>
          )}
        </TabView>
      </FavoritesTabContainer>
    </div>
  )
}
